import React from 'react'

import {TableHeaderRow} from "@devexpress/dx-react-grid-material-ui"
import {Filter} from "../Filter"

export const TableHeaderContent = (props) => {
    const {column, unit, children, ...restProps} = props

    let button = null

    switch (column.name) {
        case 'value':
        case 'active':
        case 'created':
        case 'updated':
            button = <Filter name={column.name} unit={unit}/>
            break
        default:
            break
    }

    return (
        <TableHeaderRow.Content
            column={column}
            {...restProps}
            style={{
                justifyContent: 'space-between'
            }}
        >
            {children}
            {button}
        </TableHeaderRow.Content>
    )
}
